var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 203,
    viewBox: "0 0 375 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 375,
    height: 203,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3059_17283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.416 58.4496C214.416 64.1647 205.508 81.0188 200.401 90.2126C200.054 90.8364 199.548 91.3561 198.934 91.7179C198.32 92.0797 197.621 92.2704 196.909 92.2704C196.197 92.2704 195.498 92.0797 194.885 91.7179C194.271 91.3561 193.764 90.8364 193.418 90.2126C188.311 81.0188 179.403 64.1647 179.403 58.4496C179.403 50.4377 187.241 43.9427 196.909 43.9427C206.578 43.9427 214.416 50.4377 214.416 58.4496Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.992 67.8461C202.257 67.8461 206.526 63.5653 206.526 58.2847C206.526 53.0041 202.257 48.7234 196.992 48.7234C191.726 48.7234 187.458 53.0041 187.458 58.2847C187.458 63.5653 191.726 67.8461 196.992 67.8461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.264 86.4957C113.464 86.4957 119.302 80.6418 119.302 73.4208C119.302 66.1997 113.464 60.3458 106.264 60.3458C99.0635 60.3458 93.2263 66.1997 93.2263 73.4208C93.2263 80.6418 99.0635 86.4957 106.264 86.4957Z",
    fill: "#F2C94C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.909 170C214.339 170 228.469 168.906 228.469 167.557C228.469 166.207 214.339 165.114 196.909 165.114C179.48 165.114 165.35 166.207 165.35 167.557C165.35 168.906 179.48 170 196.909 170Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.609 85.0481C104.273 80.9474 101.496 77.0836 97.4068 76.4182C93.3178 75.7527 89.4651 78.5376 88.8016 82.6383C88.138 86.739 90.9149 90.6027 95.0039 91.2681C99.0929 91.9336 102.946 89.1488 103.609 85.0481Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.69 122.646C212.623 100.44 140.581 122.089 98.9864 166.373C98.75 166.621 98.5136 166.873 98.2846 167.126H97.6504C97.8681 166.873 98.0932 166.621 98.3147 166.373C140.772 118.721 211.857 99.7291 271.69 122.646Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.832 130.012C282.611 127.219 277.219 124.759 271.69 122.646C277.234 124.725 282.627 127.186 287.832 130.012Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M255.504 107.857C260.047 107.857 263.73 104.163 263.73 99.6068C263.73 95.0504 260.047 91.3567 255.504 91.3567C250.961 91.3567 247.277 95.0504 247.277 99.6068C247.277 104.163 250.961 107.857 255.504 107.857Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.42 163.065C257.056 165.422 259.233 166.881 259.233 166.881C259.233 166.881 260.38 164.52 259.744 162.163C259.109 159.806 256.931 158.347 256.931 158.347C256.931 158.347 255.784 160.708 256.42 163.065Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.354 162.558C259.099 164.261 259.312 166.879 259.312 166.879C259.312 166.879 256.696 166.736 254.952 165.033C253.207 163.33 252.994 160.712 252.994 160.712C252.994 160.712 255.61 160.855 257.354 162.558Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.261 130.296V133.932L81.0808 134.127V130.258C81.1409 130.27 81.2009 130.285 81.261 130.296Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8126 166.371C92.76 166.458 92.7037 166.544 92.6475 166.631H81.0808V130.477L81.261 130.296L82.7959 132.046V129.487H87.6748V137.609L92.6024 143.221L92.6475 143.273C92.7075 143.461 92.7638 143.65 92.8201 143.838C92.8205 143.841 92.8218 143.843 92.8238 143.845C93.5629 146.217 94.1693 148.628 94.6403 151.068C95.7136 156.823 95.5522 162.099 92.8126 166.371Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.142 150.28H82.0366V152.876H85.142V150.28Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.142 154.952H82.0366V157.547H85.142V154.952Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.8 145.349L179.248 142.754L193.739 130.297C204.453 125.126 217.367 126.618 231.004 130.297V133.93L217.547 148.464L202.02 151.578L180.8 145.349Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.418 137.607C239.992 134.737 240.349 132.007 237.418 129.487H232.54V132.047L231.004 130.297L218.582 142.754L216.512 144.83L213.924 155.211L218.582 166.63H242.39V143.273L237.418 137.607Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.247 142.754H218.582V166.63H179.247C174.489 161.467 176.961 152.056 179.247 142.754Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.148 150.28H204.867V157.547H213.148V150.28Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.503 150.021H194.257V166.63H201.503V150.021Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.976 152.616V150.021H182.871V152.616H185.717H185.976Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.717 154.692H182.871V157.288H185.976V154.692H185.717Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.151 150.021H188.046V152.616H191.151V150.021Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.151 154.692H188.046V157.287H191.151V154.692Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.71 152.876V150.28H226.604V152.876H229.451H229.71Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.451 154.952H226.604V157.547H229.71V154.952H229.451Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.885 150.28H231.78V152.876H234.885V150.28Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.885 154.952H231.78V157.547H234.885V154.952Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.762 101.75L108.174 99.6737L122.666 86.6976H159.413V98.1167L135.605 114.207L110.762 101.75Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.112 93.9765V86.9568H161.233V88.6761L159.412 86.6975L147.508 99.6736L142.851 102.788L135.628 155.707L146.52 166.63H171.834C175.713 147.063 178.788 126.963 171.834 100.193L166.112 93.9765Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.174 99.6737H147.508V166.63H108.174C103.869 140.618 101.767 116.496 108.174 99.6737Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.688 150.28H123.442V166.63H130.688V150.28Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.678 154.952V152.357H112.573V154.952H115.42H115.678Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42 157.028H112.573V159.623H115.678V157.028H115.42Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.854 152.356H117.749V154.952H120.854V152.356Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.64 157.028H133.793V159.623H136.898V157.028H136.64Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.074 152.356H138.969V154.952H142.074V152.356Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.074 157.028H138.969V159.623H142.074V157.028Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.636 103.048V100.453H155.531V103.048H158.377H158.636Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.377 105.124H155.531V107.719H158.636V105.124H158.377Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.812 100.452H160.706V103.048H163.812V100.452Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.812 105.124H160.706V107.719H163.812V105.124Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.636 117.581V114.986H155.531V117.581H158.377H158.636Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.377 119.657H155.531V122.252H158.636V119.657H158.377Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.812 114.985H160.706V117.581H163.812V114.985Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.812 119.657H160.706V122.252H163.812V119.657Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.636 132.114V129.519H155.531V132.114H158.377H158.636Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.377 134.19H155.531V136.785H158.636V134.19H158.377Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.812 129.519H160.706V132.114H163.812V129.519Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.812 134.19H160.706V136.785H163.812V134.19Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.636 146.647V144.052H155.531V146.647H158.377H158.636Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.377 148.723H155.531V151.318H158.636V148.723H158.377Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.812 144.052H160.706V146.647H163.812V144.052Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.812 148.723H160.706V151.318H163.812V148.723Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.573 103.048H142.592V109.276C132.97 106.613 122.936 106.804 112.573 109.276V103.048Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.573 115.505C121.942 118.273 131.948 118.273 142.592 115.505V121.733H112.573V115.505Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.573 127.962H142.592V134.19C132.361 130.914 122.345 130.76 112.573 134.19V127.962Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.573 140.419C122.363 144.202 132.378 144.045 142.592 140.419V146.647H112.573V140.419Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.908 129.598H295V139.79L293.116 140.381L286.849 142.343L277.016 140.058L267.194 137.776L262.008 136.571L259.418 135.61C261.572 132.646 265.491 130.314 273.908 129.598Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 135.61V166.631H259.418C259.407 166.611 259.399 166.594 259.388 166.575V166.573C259.38 166.551 259.37 166.531 259.358 166.51C258.803 165.389 258.305 164.271 257.864 163.155C254.13 153.717 254.536 144.527 259.418 135.61H295Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.932 150.28H274.686V166.63H281.932V150.28Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.923 154.952V152.357H263.818V154.952H266.664H266.923Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.664 157.028H263.818V159.623H266.923V157.028H266.664Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.099 152.356H268.993V154.952H272.099V152.356Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.099 157.028H268.993V159.623H272.099V157.028Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.143 154.952V152.357H285.038V154.952H287.884H288.143Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.884 157.028H285.038V159.623H288.143V157.028H287.884Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.319 152.356H290.213V154.952H293.319V152.356Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.319 157.028H290.213V159.623H293.319V157.028Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.195 117.554H271.656C276.056 117.554 280.275 119.307 283.386 122.427C286.497 125.546 288.245 129.778 288.245 134.19H267.195V117.554Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.088 72.3896H136.549C140.949 72.3896 145.168 74.1424 148.279 77.2622C151.39 80.3821 153.138 84.6136 153.138 89.0257H132.088V72.3896Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.395 114.167H207.855C212.255 114.167 216.474 115.919 219.585 119.039C222.696 122.159 224.444 126.391 224.444 130.803H203.395V114.167Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.244 140.419H267.195V146.647H288.244V140.419Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 166.373H81.0811V167.126H295V166.373Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.811 136.638H100.06V166.371H100.811V136.638Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.738 140.427C107.785 150.824 100.491 159.286 100.491 159.286C100.491 159.286 91.1506 150.712 93.0723 140.495C95.0049 130.22 101.028 121.679 100.318 121.635C100.318 121.635 107.69 130.03 107.738 140.427Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.87 136.638H175.119V166.371H175.87V136.638Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.797 140.427C183.474 150.802 175.551 159.286 175.551 159.286C175.551 159.286 168.179 150.892 168.132 140.495C168.084 130.098 175.378 121.635 175.378 121.635C174.667 124.485 182.25 132.032 182.797 140.427Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.105 88.3059L159.708 86.7063L173.385 98.1551L170.967 100.344L149.309 99.8555L127.105 88.3059Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5728 141.437L92.8164 143.029L92.6025 143.221L92.1559 143.627L81.0809 143.379V130.258C80.7206 130.179 80.3603 130.104 80 130.033L80.897 129.987L81.0809 130.142L82.796 131.576L87.6748 135.663L93.1241 140.225L94.5728 141.437Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.411 131.588L231.014 129.989L244.691 141.438L242.273 143.627L220.615 143.138L198.411 131.588Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3059_17283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 136,
    fill: "white",
    transform: "translate(80 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.8b9cfb424c2a5ab4729e4604c92fba78.svg";
export { ForwardRef as ReactComponent };